import { useEffect, useRef } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { loadMostRecentActivityLog } from '@/store/slices/project';

const useGetActivityLog = (channel: number | null, projectUuid: string | undefined): void => {
  const fetched = useRef<string | undefined>(undefined);

  const dispatch = useAppDispatch();

  useEffect(() => {
    (async () => {
      if (channel && projectUuid && !(fetched.current === projectUuid)) {
        try {
          fetched.current = projectUuid;
          await dispatch(
            loadMostRecentActivityLog({
              channel,
              projectUuid,
            })
          );
        } catch (error) {
          console.error(error);
        }
      }
    })();
  }, [dispatch, channel, projectUuid]);
};

export default useGetActivityLog;
